import React from "react";
import CloseButton from "./CloseButton";
import Selectric from "./Selectric";
import DashboardCollapse from "./DashboardCollapse";

export default function SortSelect(props) {

    const { sortLabel,
        closeSortLabel,
        sortOptions,
        sortType,
        activeDashboardCollapse,
        handleSortSelectChange,
        handleDashboardCollapse } = props;


    return (
        <DashboardCollapse className="select select--alt" id="sort-select" activeDashboardCollapse={activeDashboardCollapse}>
            <div className="select__actions">
                <CloseButton
                    closeDashboardToggleId="#sort-select"
                    handleDashboardCollapse={handleDashboardCollapse}
                    closeText={closeSortLabel} />
            </div>
            <label htmlFor="sort">{sortLabel}</label>
            <Selectric defaultValue={sortType} onChange={handleSortSelectChange} id="sort">
                {sortOptions.map((so, i) => (
                    <option key={`sortOption-${i}`} value={so.SortType}>
                        {so.DisplayName}
                    </option>
                ))}
            </Selectric>
        </DashboardCollapse>
    );
}